import DataSelectionModel from "./DataSelectionModal";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import { useDataSelectionContext } from "./DataSelectionContext";
import { useMemo } from "react";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { WfsGetOSHighwaysRequest } from "../../types/Wfs/WfsGetOSHighwaysRequest";

interface HighwaysFormValues {
  outputFormat: string;
  users?: number;
  featureType: string;
}

const Highways = () => {
  const { mode } = useParams();
  const layerName = "os:highways";
  const { layers, getLayer, wfsOrder } = useDataSelectionContext();
  const layer = useMemo(() => getLayer(layerName), [layers]);

  const initialValues = useMemo(
    () =>
      ({
        outputFormat: "gml",
        users: layer?.isPremium ? 1 : undefined,
        featureType: "roads",
      } as HighwaysFormValues),
    [layer],
  );
  const schema = useMemo(
    () =>
      yup.object({
        outputFormat: yup.string().oneOf(["gml"]).required(),
        users: yup.number().min(1).required(),
      }),
    [layer],
  );

  const onSubmit = (values: HighwaysFormValues) => {
    wfsOrder({
      service: "WFS",
      version: "2.0.0",
      request: "GetFeature",
      resultType: "Results",
      typeNames: layerName,
      outputFormat: values.outputFormat,
      sortBy: "RoadLinkId",
      users: values.users,
      featureType:
        mode?.toLowerCase() === "rami"
          ? "roads"
          : mode?.toLowerCase() === "ramiandpaths"
          ? "roadsandpaths"
          : values.featureType,
    } as WfsGetOSHighwaysRequest);
  };

  return (
    <DataSelectionModel
      headerText="OS Highways"
      layer={layer}
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <>
          <Form.Group>
            <Form.Label>Road Network Type</Form.Label>
            {mode?.toLowerCase() !== "rami" &&
              mode?.toLowerCase() !== "ramiandpaths" && (
                <ToggleButtonGroup
                  type="radio"
                  name="featureType"
                  id="featureType"
                  defaultValue={values.featureType}
                  onChange={handleChange}>
                  <ToggleButton
                    id="roads"
                    value="roads"
                    variant="outline-primary"
                    onChange={handleChange}>
                    OS Highways RAMI
                  </ToggleButton>
                  <ToggleButton
                    id="roadandpaths"
                    value="roadsandpaths"
                    variant="outline-primary"
                    onChange={handleChange}>
                    OS Highways RAMI and Paths
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            {mode?.toLowerCase() === "rami" && (
              <div>
                <span className="btn btn-primary">OS Highways RAMI</span>
              </div>
            )}
            {mode?.toLowerCase() === "ramiandpaths" && (
              <div>
                <span className="btn btn-primary">
                  OS Highways RAMI and Paths
                </span>
              </div>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="users">
              Users or terminals to licence for
            </Form.Label>
            <Form.Control
              id="users"
              name="users"
              type="number"
              min={1}
              step={1}
              value={values.users}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.users && !errors.users}
              isInvalid={touched.users && !!errors.users}
            />
            {errors.users && (
              <Form.Control.Feedback type="invalid">
                {errors.users}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="outputFormat">Format</Form.Label>
            <Form.Select
              id="outputFormat"
              name="outputFormat"
              value={values.outputFormat}
              onChange={handleChange}
              onBlur={handleBlur}>
              <option value="gml">GML 3</option>
            </Form.Select>
          </Form.Group>
        </>
      )}
    </DataSelectionModel>
  );
};

export default Highways;
